import graphql__81c28f3d3bed85ef97d0 from "./__generated__/DeleteAppModalQuery.graphql.ts";
import graphql__977e69fcf814d5623fb2 from "./__generated__/DeleteAppModalMutation.graphql.ts";import { MessagePanel } from '@portal/components'
import graphql from 'babel-plugin-relay/macro'
import ConfirmationModal from 'components/confirmation/ConfirmationModal'
import TextBoxConfirmation from 'components/confirmation/TextBoxConfirmation'
import { useAppToDatabaseRename } from 'components/hooks'
import { useState } from 'react'
import { useLazyLoadQuery } from 'react-relay/hooks'
import { toast } from 'sonner'
import { usePortalMutation } from 'utils'

import { DeleteAppModalMutation } from './__generated__/DeleteAppModalMutation.graphql'
import { DeleteAppModalQuery } from './__generated__/DeleteAppModalQuery.graphql'

const query = graphql__81c28f3d3bed85ef97d0

const deleteMutation = graphql__977e69fcf814d5623fb2

type Props = {
  /** True if the modal is open. */
  isOpen: boolean
  /** Callback for closing the modal */
  onClose: (redirect: boolean) => void
  /** ID of the app being deleted. */
  appId: string
}

/** Modal used to confirm that an app should be deleted. */
const DeleteAppModal = ({ isOpen, onClose, appId }: Props) => {
  const { viewer } = useLazyLoadQuery<DeleteAppModalQuery>(query, { id: appId })
  const [deleteApp, isDeletingApp] = usePortalMutation<DeleteAppModalMutation>(
    deleteMutation,
    {
      mutationName: 'DeleteApp',
      sentryContext: {
        component: 'DeleteAppModal',
        appId,
      },
      showErrorToast: false,
    },
  )
  const { databaseText } = useAppToDatabaseRename()

  const [isMatch, setIsMatch] = useState(false)
  const appSlug = viewer.appById?.slug

  const titleText = `Delete ${databaseText}`

  const submit = () => {
    deleteApp({
      variables: {
        id: appId,
      },
      onCompleted: () => onClose(true),
      onError: () => {
        toast.error(`We ran into an issue deleting the ${databaseText}`)
      },
    })
  }

  return (
    <ConfirmationModal
      open={isOpen}
      onCancel={() => onClose(false)}
      onConfirm={submit}
      title={titleText}
      confirmButtonText="Confirm"
      cancelButtonDisabled={isDeletingApp}
      confirmButtonDisabled={!isMatch || isDeletingApp}
      variant="warning"
      description={`Are you sure you want to delete your ${databaseText}?`}
      data-testid="modalDialogPanel"
    >
      <MessagePanel
        variant="danger"
        message={`Once you confirm this action there's no going back. Be certain that you want to delete this ${databaseText} and all data related to it.`}
        className="mb-8"
      />
      <TextBoxConfirmation onMatch={setIsMatch} value={appSlug || ''} />
    </ConfirmationModal>
  )
}

export default DeleteAppModal
